module.exports = "/_next/static/images/eacd9f4364e995bb717b7a826a03fe3b-card-and-phone-3d-md@3x.jpg.webp";